import React from "react";
import { useTable } from "../../Components/useTable";

const DiamondList = () => {
  const type = "Send Diamonds";
  const headCells = [
    { id: "toUser.code", numeric: false, label: "Reciever RID" },
    { id: "toUser.name", numeric: false, label: "Reciever Name" },
    { id: "amount", numeric: false, label: "Diamonds Sent" },
    { id: "reason", numeric: false, label: "Reason" },
    { id: "currentDiamond", numeric: false, label: "Previous Balance" },
    { id: "type", numeric: false, label: "Type" },
    { id: "status", numeric: false, label: "Status" },
    { id: "fromUser.code", numeric: false, label: "Sending RID" },
    { id: "fromUser.name", numeric: false, label: "Sending Person" },
    { id: "createdAt", numeric: false, label: "Created at" },
    // { id: "quantity", numeric: false, label: "Quantity" },
    // { id: "currentRcoin", numeric: false, label: "Current Rcoin" },
    // { id: "action", numeric: false, label: "Action" },
  ];

  const { tableUI } = useTable({
    headCells,
    type,
  });
  return (
    <div className="admin-body">
      <div className="table-area">{tableUI}</div>
    </div>
  );
};

export default DiamondList;
